import { createRouter } from "@tanstack/react-router";
import { LoadingState } from "@hyperoll/ui";

import { routeTree } from "./routeTree.gen";

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  defaultPendingMs: 0,
  defaultPendingMinMs: 250,
  defaultPendingComponent: () => (
    <main className="grid min-h-screen place-items-center p-6">
      <LoadingState label="Loading Partner Dashboard…" />
    </main>
  ),
  scrollRestoration: true,
  defaultNotFoundComponent: () => (
    <main className="grid min-h-screen place-items-center p-6">
      <div className="text-center">
        <p className="eyebrow">Partner Dashboard</p>
        <h1>Page not found</h1>
      </div>
    </main>
  ),
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
